module.exports = __webpack_public_path__ + "static/media/logo-word-mark-negative.03cfb98a.svg";